import { useMemo } from "react";
import { useUnit } from "effector-react";
import cx from "classnames";
import {
  $orderedSightIds,
  $sightsStore,
  // clearFocusedSight,
  // clearOrbitTargetOverride,
  userSelectedSight,
  // setOrbitAnimationEnabled,
  // setVirtualTour,
  // stopVirtualTour,
} from "../../state/appState";
// import { $audioConfig, updateAudioConfig, updateCameraConfig } from "../../state/appConfig";
import type { Sight, SightId } from "../../types";
// import { SwitchControl } from "../SwitchControl/SwitchControl";
import styles from "./MenuOverlay.module.css";
import { Button } from "../Button";
import CloseIcon from "../../icons/close.svg?react";
import { SettingsList } from "../SettingsList";
import { UnstyledButton } from "../UnstyledButton";
// import { setViewMode } from "../../state/viewMode";
import { useI18n, formatMessage } from "../../i18n";

type MenuOverlayProps = {
  open: boolean;
  onClose: () => void;
  onReturnToMap: () => void;
};

export function MenuOverlay({ open, onClose, onReturnToMap }: MenuOverlayProps) {
  const i18n = useI18n();
  const {
    sights,
    orderedSightIds,
    // audioConfig,
    // updateAudio,
    // startVirtualTour,
    // stopTour,
    // resetFocusedSight,
    // resetOrbitTarget,
    // updateCamera,
    // updateViewMode,
    // setOrbitAnimation,
  } = useUnit({
    sights: $sightsStore,
    orderedSightIds: $orderedSightIds,
    // audioConfig: $audioConfig,
    // updateAudio: updateAudioConfig,
    // startVirtualTour: setVirtualTour,
    // stopTour: stopVirtualTour,
    // resetFocusedSight: clearFocusedSight,
    // resetOrbitTarget: clearOrbitTargetOverride,
    // updateCamera: updateCameraConfig,
    // updateViewMode: setViewMode,
    // setOrbitAnimation: setOrbitAnimationEnabled,
  });
  const [navigateToSight] = useUnit([userSelectedSight]);

  // const clampPercent = (value: number) =>
  //   Math.round(
  //     Math.min(1, Math.max(0, Number.isFinite(value) ? value : 1)) * 100
  //   );
  // const voiceVolumePercent = clampPercent(audioConfig.voiceVolume);
  // const musicVolumePercent = clampPercent(audioConfig.musicVolume);

  const locations = useMemo(() => {
    return orderedSightIds
      .map((id) => sights[id])
      .filter((item): item is Sight => Boolean(item));
  }, [orderedSightIds, sights]);

  const handleSelect = (id: SightId) => {
    onClose();
    navigateToSight({ id, smooth: true });
  };

  const handleReturnToMap = () => {
    onClose();
    onReturnToMap();
  };

  // const handleStartJourney = () => {
  //   onClose();
  //   startVirtualTour(kaabaSceneConfig.virtualTour);
  // };

  // const handleFreeRoam = () => {
  //   onClose();
  //   stopTour();
  //   resetFocusedSight();
  //   resetOrbitTarget();
  //   setOrbitAnimation(false);
  //   updateViewMode("orbit");
  //   updateCamera({ orbitAutoMove: true });
  // };

  // TODO: Убогий костыль, заменить на халяльную переменную
  const shouldShowMekkaButton = !window.location.hostname.startsWith('pilgrim-balady');

  return (
    <div
      className={cx(styles.overlay, !open && styles.hidden)}
      aria-hidden={!open}
    >
      <div className={styles.panel}>
        <Button
          onClick={onClose}
          className={styles.closeButton}
          aria-label={i18n.menu.closeMenu}
        >
          <CloseIcon />
        </Button>

        <div className={styles.panelIn}>
          {shouldShowMekkaButton && (
            <div className={styles.widgets}>
              <UnstyledButton
                className={cx(styles.widget, styles.mekka)}
                onClick={handleReturnToMap}
              >
                {i18n.menu.makkah}
              </UnstyledButton>
            </div>
          )}
          {/* <div className={styles.widgets}>
            <UnstyledButton
              className={cx(styles.widget, styles.freeRoam)}
              onClick={handleFreeRoam}
            >
              {i18n.menu.freeRoam}
            </UnstyledButton>
            <UnstyledButton
              className={cx(styles.widget, styles.journey)}
              onClick={handleStartJourney}
            >
              {i18n.menu.startJourney}
            </UnstyledButton>
          </div> */}

          {/* <SettingsList title={i18n.menu.settingsTitle}>
            <div className={styles.switch}>
              <span>{i18n.menu.soundLabel}</span>
              <SwitchControl
                checked={audioConfig.soundOn}
                onToggle={(next) => updateAudio({ soundOn: next })}
              />
            </div>
          </SettingsList> */}

          {/* {audioConfig.soundOn && (
            <SettingsList title={i18n.menu.audioTitle}>
              <div className={styles.switch}>
                <span>{i18n.menu.voiceLabel}</span>
                <SwitchControl
                  checked={audioConfig.voiceOn}
                  onToggle={(next) => updateAudio({ voiceOn: next })}
                />
              </div>
              <div className={styles.switch}>
                <span>{i18n.menu.musicLabel}</span>
                <SwitchControl
                  checked={audioConfig.musicOn}
                  onToggle={(next) => updateAudio({ musicOn: next })}
                />
              </div>
            </SettingsList>
          )} */}

          <SettingsList title={i18n.menu.allLocationsTitle}>
            {locations.map((sight) => (
              <UnstyledButton
                type="button"
                className={styles.poi}
                role="listitem"
                onClick={() => handleSelect(sight.id)}
              >
                <div className={styles.poiIconFrame}>
                  {sight.icon ? (
                    <img
                      src={sight.icon.src}
                      srcSet={sight.icon.srcSet}
                      alt={
                        sight.icon?.alt ??
                        (sight.name
                          ? formatMessage(i18n.menu.sightIconAlt, {
                              name: sight.name,
                            })
                          : '')
                      }
                      width={20}
                      height={20}
                      className={styles.poiIcon}
                      loading="lazy"
                    />
                  ) : (
                    <span className={styles.poiFallback} aria-hidden />
                  )}
                </div>
                <div className={styles.poiText}>
                  <span className={styles.poiName}>{sight.name}</span>
                </div>
              </UnstyledButton>
            ))}
          </SettingsList>
        </div>
      </div>
    </div>
  );
}
